import { useEffect, useState } from 'react';

const hasFocus = () => typeof document !== 'undefined' && document.hasFocus();

/**
 * A hook that checks if the application window is actively focused.
 *
 * @returns whether the window is focused or not
 */
export function useWindowFocus(): boolean {
  const [focused, setFocused] = useState(hasFocus);

  useEffect(function syncWindowFocusListeners() {
    setFocused(hasFocus());

    const onFocus = () => setFocused(true);
    const onBlur = () => setFocused(false);

    const abortController = new AbortController();
    window.addEventListener('focus', onFocus, {
      signal: abortController.signal,
    });
    window.addEventListener('blur', onBlur, {
      signal: abortController.signal,
    });

    return () => abortController.abort();
  }, []);

  return focused;
}
